import auth from '@/auth'

export default {
  created() {
    this.$auth = auth
  },
}
